import { SearchResultType } from "@/api/fleet-tracking/types";
import { searchMod } from '@/store/modules/search';

export function getRunStatusColour(status: string) {
  switch (status) {
    case 'Activated':
      return 'var(--consignment-staged-colour)';
    case 'Enroute':
      return 'var(--consignment-picked-up-colour)';
    case 'Completed':
      return 'var(--consignment-in-transit-colour)';
    case 'Closed':
      return 'var(--consignment-delivered-colour)';
  }
}

export function getMapElementColour(index: number): string {
  return mapElementColours[index % mapElementColours.length];
}

export function getMapElementColourBySearch(id: string, searchResultType: SearchResultType): string {
  const searchResults = searchMod.getSearchResults;
  const index = searchResults.findIndex(x => (x.deliveryRunReference == id || x.fleetNumber == id) && x.searchResultType == searchResultType);

  return getMapElementColour(index);
}

export const mapElementColours = [
  '#6F9696',
  '#BD00BF',
  '#6C72A1',
  '#BF8E3A',
  '#009662',
  '#006C8E',
  '#1300BD',
  '#909C00'
];

export default { getRunStatusColour, getMapElementColour, getMapElementColourBySearch };
